import React, {useEffect, useState, useRef} from "react";
import styles from "../../css/community-my-questions-detailed.module.css";
import style from "../../css/myquestions.module.css";
import editIcon from "../../../../public/images/edit_white.svg";
import deleteIcon from "../../../../public/images/delete_white.svg";
import copyLinkIcon from "../../../../public/images/copyLinkIcon.svg";
import { Provider, useSelector } from "react-redux";
import newAdminStore from "../../../admin/store/newAdminStore";
import SearchContainer from "../../../admin/containers/SearchContainer";
import ActionButtonContainer from "../../../shared/containers/ActionButtonContainer";
import { getDate } from "../../../app/dashboard/utils/get-date";
import ModalDialog from "../../../shared/components/ModalDialog";
import { useDispatch } from "react-redux";
import { COMMUNITY_ACTION_TYPES } from "./communityReducer";
import { useCommunityDelete } from "./CommunityCustomHooks/useCommunityDelete";
import PopUpContainer from "../../../shared/components/PopUpContainer";
import AskEditQuestionPopUp from "./CommunityPopUps/AskEditQuestionPopUp";
import {PAGE_HASH_LOCATION} from "../../../app/utils/pages";
import editIconMobile from "../../../../public/images/icons/community-edit-icon.svg";
import deleteIconMobile from "../../../../public/images/icons/community-delete-icon.svg";
import backRounded from "../../../../public/images/back_rounded.svg"
import questionsIcon from "../../../../public/images/community-qns-icon.svg";
import {isMobileOnly} from "react-device-detect";
import {deleteQuestion, fetchUserQuestions} from "../../../shared/utils/sash-v2-api";
import Paginator from "../../../shared/components/Paginator";
import TopNavBar from "../TopNavBar";
import * as JSONWebToken from "jsonwebtoken";
import {getSASHWebToken} from "../../../app/utils/jwt";
import searchBlue from "../../../../public/images/search-blue.svg";


const CommunityMyQuestionsDetailed = (props) => {
  const [copyStatuses, setCopyStatuses] = useState({});
  const [askPopUp, setAskPopUp] = useState(false);
  const [editPopUp, setEditPopUp] = useState(false);
  const [questionToEdit, setQuestionToEdit] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const dispatch = useDispatch();
  const {deletePopUp, threadToDelete, handleCommunityDeletePopUp, handleCommunityDeletePopUpClose} = useCommunityDelete();
  const [copiedQuestionId, setCopiedQuestionId] = useState(null);
  const userQuestion = useSelector((state) => state.communityReducer.userQuestions);
  const userQuestionsCount = useSelector((state) => state.communityReducer.userQuestionsCount);
  const tokenData = JSONWebToken.decode(getSASHWebToken());
  const user =  (tokenData && tokenData.userId) ? tokenData.userId : undefined;
  const [pageIndex, setPageIndex] = useState(0);
  const [cachedData, setCachedData] = useState({});
  const isInitialMount = useRef(true);
  const QUESTIONS_PER_PAGE = 50


  const handleSuccess = (res, index) => {
    dispatch({
      type: COMMUNITY_ACTION_TYPES.SET_USER_QUESTIONS,
      payload: res.questions || res.searchedQuestions,
    });
    dispatch({
      type: COMMUNITY_ACTION_TYPES.SET_USER_QUESTIONS_COUNT,
      payload: res.total_count,
    });
    setCachedData((prevData) => ({
      ...prevData,
      [index]: res.questions || res.searchedQuestions,
    }));
  };

  const failureFunction = (error) => {
    console.error('Error fetching questions:', error);
  };

  const userAskedQuestions = (index) => {
    if (cachedData[index]) {
      dispatch({
        type: COMMUNITY_ACTION_TYPES.SET_USER_QUESTIONS,
        payload: cachedData[index],
      });
      return;
    }
    fetchUserQuestions((response) => handleSuccess(response, index), failureFunction, searchTerm ? 100 : QUESTIONS_PER_PAGE,  index, searchTerm);
  };


  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      if (user) {
        userAskedQuestions(pageIndex);
      }
      return;
    }
    if (user) {
      userAskedQuestions(pageIndex);
    }
  }, [user, pageIndex, searchTerm]);

  const handlePageChange = (pageIndex) => {
    if (user) {
      setPageIndex(pageIndex.selected);
    }
  }

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.type === 'click') {
      if (searchTerm) {
        userAskedQuestions()
      }
    }
  }



  const handleCopyLink = (threadId) => {
    const link = `${window.location.origin}/#community/?id=${threadId}`;
    navigator.clipboard
        .writeText(link)
        .then(() => {
          setCopiedQuestionId(threadId);
          setCopyStatuses((prevState) => ({
            ...prevState,
            [threadId]: "Link Copied",
          }));

          setTimeout(() => {
            setCopiedQuestionId(null);
            setCopyStatuses((prevState) => ({
              ...prevState,
              [threadId]: "Copy Link",
            }));
          }, 2000);
        })
        .catch((error) => {
          console.error("Failed to copy text: ", error);
        });
  };

  const handleQuestionClick = (threadId) => {
    window.location.href = window.location.origin + PAGE_HASH_LOCATION.community + `/?id=${threadId}`;
  };

  const handleAddQuestion = () => {
    setAskPopUp(true);
  };

  const closePopUp = () => {
    setAskPopUp(false);
    setEditPopUp(false);
  };

  const handleTextChange = (text) => {
    setSearchTerm(text);
  };

  const handleDeleteThread = () => {
    if (threadToDelete) {
      const questionId = threadToDelete;
      const successFunction = () => {
        const updatedThreads = userQuestion.filter(
            (thread) => thread._id !== questionId
        )
        dispatch({
          type: COMMUNITY_ACTION_TYPES.SET_USER_QUESTIONS,
          payload: updatedThreads,
        });
        handleCommunityDeletePopUpClose();
      };

      const failureFunction = (error) => {
        console.error("Failed to delete thread:", error);
        alert("not deleted")
        handleCommunityDeletePopUpClose();
      };

      deleteQuestion(questionId, successFunction, failureFunction);
    }
    else {
      handleCommunityDeletePopUpClose();
    }
  };

  const handleEditThread = (thread) => {
    setQuestionToEdit(thread);
    setEditPopUp(true);
  };

  return (
      <>
        {
          !isMobileOnly ?
              <>
                <div style={{backgroundColor:'white',marginTop:'-20px'}}>
                  <TopNavBar color={"black"} isCommunity={true}/>
                </div>
                <div style={{backgroundColor: '#F5F5F5'}}>
                  <div className={styles.questionDetailedMain}>
                    <div className={styles.myQuesContainer}>
                      <img style={{cursor: 'pointer'}}
                           onClick={() => window.location.href = window.location.origin + PAGE_HASH_LOCATION.community}
                           src={backRounded} alt='back' height={35}/>
                      <span className={styles.myQues}>My Questions</span>
                    </div>
                    <div className={styles.searchContainer}>
                      <div className={styles.searchWrapper}>
                        <Provider store={newAdminStore}>
                          <SearchContainer handleTextChange={handleTextChange} handleKeyDown={handleKeyDown} width={800}/>
                        </Provider>
                      </div>
                      <ActionButtonContainer
                          buttonText={"+Ask Question"}
                          handleClick={handleAddQuestion}
                          buttonWidth="140px"
                          height="35px"
                          fontSize="14px"
                      />
                    </div>
                    <div className={styles.questionsContainer}>
                      {userQuestion?.length === 0 ? (
                          <p className={styles.noQuestions}>No questions found.</p>
                      ) : (
                          userQuestion?.map((question) => (
                              <div key={question._id} className={styles.questionItem}>
                                <div className={styles.head}>
                                  <div className={styles.myQuestionsDetailedLeft}>
                                    <p style={{fontSize: "12px"}}>
                                      {getDate(question.created_at)}
                                    </p>
                                    <div onClick={() => handleEditThread(question)} style={{height: "20"}}
                                         className={styles.editButton}>
                                      <img style={{marginRight: "2px"}} height={12} src={editIcon} alt="edit"/>
                                      <p style={{margin: "0"}}>Edit</p>
                                    </div>
                                    <div onClick={() => handleCommunityDeletePopUp(null, question._id)}
                                         style={{height: "20"}}
                                         className={styles.deleteButton}>
                                      <img height={12} src={deleteIcon} alt="delete"/>
                                      <p style={{margin: "0"}}>Delete</p>
                                    </div>
                                  </div>
                                  <div className={styles.myQuestionsDetailedRight}>
                                    <div className={styles.answerCount}>
                                      <p>{question.answer_count} Answers</p>
                                    </div>
                                    <div className={styles.copyLink} onClick={() => handleCopyLink(question._id)}>
                                      <div style={{display: "flex", gap: "3px"}}>
                                        <img width={15} src={copyLinkIcon} alt="copyLinkIcon"/>
                                        <p>{copyStatuses[question._id] || "Copy Link"}</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div onClick={() => handleQuestionClick(question._id)} className={styles.questionBody}>
                                  <p className={styles.questionTitle}>{question.title}</p>
                                  <div>
                                    {question.description.split("\n").length > 0 ? (
                                        question.description.split("\n").map((line, index) => (
                                            <p style={{fontSize: "14px"}} key={index}>
                                              {line}
                                            </p>
                                        ))
                                    ) : (
                                        <p style={{fontSize: "14px"}}>{question.description}</p>
                                    )}
                                  </div>
                                </div>
                              </div>
                          ))
                      )}
                    </div>

                    {deletePopUp && (
                        <ModalDialog
                            header={"DELETE"}
                            body={
                              <p style={{textAlign: "center", margin: "0"}}>
                                Are you sure you want to delete your Question? <br/>
                                Deleting the question will delete all the answers <br/>
                                associated with it.
                              </p>
                            }
                            buttons={[
                              {
                                text: "CANCEL",
                                action: handleCommunityDeletePopUpClose,
                              },
                              {
                                text: "DELETE",
                                action: handleDeleteThread,
                              },
                            ]}
                        />
                    )}
                    {askPopUp && (
                        <PopUpContainer>
                          <AskEditQuestionPopUp
                              selectedThread={null}
                              onClose={closePopUp}
                          />
                        </PopUpContainer>
                    )}
                    {editPopUp && (
                        <PopUpContainer>
                          <AskEditQuestionPopUp
                              selectedThread={questionToEdit}
                              onClose={closePopUp}
                          />
                        </PopUpContainer>
                    )}
                  </div>
                </div>
                <div style={{marginTop: '-15px'}}>
                  <Paginator handlePageChange={handlePageChange} initialPage={0}
                             totalPageCount={Math.abs(userQuestionsCount / QUESTIONS_PER_PAGE)}
                             containerClassName={'community-page'}
                  />
                </div>
              </>
              :
              <>
                <div className={style.myQuestionsContainer}>
                  <div style={{marginTop: '-60px'}} className={style.questionHeader}>
                    <h1
                        style={{
                          fontSize: "27px",
                          fontWeight: "bold",
                        }}
                    >
                      My Questions
                    </h1>
                    <ActionButtonContainer
                        buttonText={"+ Ask Question"}
                        fontSize={"16px"}
                        buttonWidth={"150px"}
                        handleClick={handleAddQuestion}
                    />
                  </div>

                  <div style={{display:'flex',alignItems:'center',justifyContent:'space-between'}}>
                    <div
                        style={{
                          backgroundColor: "white",
                          width: "99%",
                          borderRadius: "20px",
                        }}
                    >
                      <SearchContainer
                          handleTextChange={handleTextChange}
                          handleKeyDown={handleKeyDown}
                          placeholder={"Search"}
                          width={"300px"}
                          padding={"10px"}
                          height={"30px"}
                      />
                    </div>
                    <div>
                      <div onClick={handleKeyDown}>
                        <img src={searchBlue} height={40} alt={'search'}/>
                      </div>
                    </div>
                  </div>



                  <div
                      className={
                        userQuestion?.length > 0
                            ? style.questionList
                            : style.noQuestionsContainer
                      }
                  >
                    {userQuestion?.length > 0 ? (
                        userQuestion?.map((question) => (
                            <div
                                key={question.id}
                            >
                              <div
                                  className={style.questionItem}
                                  onClick={() => {
                                    window.location.href =
                                        window.location.origin +
                                        PAGE_HASH_LOCATION.community +
                                        `/?id=${question._id}`;
                                    props.setSelectedQuestion(question);
                                  }}
                              >
                                <div className={style.questionHeader}>
                                  <div className={style.dateAndActions}>
                                    <span>{getDate(question.created_at)}</span>
                                    <div className={style.actions}>
                                      <img
                                          src={editIconMobile}
                                          alt="Edit"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleEditThread(question);
                                          }}
                                      />
                                      <img
                                          src={deleteIconMobile}
                                          alt="Delete"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleCommunityDeletePopUp(null, question._id);
                                          }}
                                      />
                                    </div>
                                  </div>

                                  <div className={style.answersSection}>
                    <span className={style.answersCount}>
                      {question.answer_count || 0}{" "}
                      {question.answer_count === 1 ? "Answer" : "Answers"}
                    </span>
                                    {copiedQuestionId === question._id ? (
                                        <span>Copied!</span>
                                    ) : (
                                        <img
                                            src={copyLinkIcon}
                                            alt="Copy link"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              handleCopyLink(question._id);
                                            }}
                                        />
                                    )}
                                  </div>
                                </div>

                                <div className={style.questionContent}>
                                  <h3>{question.title}</h3>
                                  <p>{question.description}</p>
                                </div>
                              </div>
                            </div>
                        ))
                    ) : (
                        <div className={style.noQuestionsContainer}>
                          <img
                              src={questionsIcon}
                              alt="No Questions"
                              className={style.noQnsIcon}
                          />
                          <p className={style.noQuestionsText}>
                            You haven't asked any questions yet.
                          </p>
                        </div>
                    )}
                  </div>

                  {askPopUp && (
                      <PopUpContainer>
                        <AskEditQuestionPopUp
                            selectedThread={null}
                            onClose={closePopUp}
                        />
                      </PopUpContainer>
                  )}

                  {editPopUp && (
                      <PopUpContainer>
                        <AskEditQuestionPopUp
                            selectedThread={questionToEdit}
                            onClose={closePopUp}
                        />
                      </PopUpContainer>
                  )}

                  {deletePopUp && (
                      <ModalDialog
                          header={"DELETE"}
                          body={
                            <p style={{textAlign: "center", margin: "0"}}>
                              Are you sure you want to delete this question? <br/>
                              Deleting the question will delete all the answers <br/>
                              associated with it.
                            </p>
                          }
                          buttons={[
                            {
                              text: "CANCEL",
                              action: handleCommunityDeletePopUpClose,
                            },
                            {
                              text: "DELETE",
                              action: handleDeleteThread,
                            },
                          ]}
                      />
                  )}
                </div>
                <div>
                  <Paginator handlePageChange={handlePageChange} initialPage={0}
                             totalPageCount={Math.abs(userQuestionsCount / QUESTIONS_PER_PAGE)}
                             containerClassName={'community-page'}
                  />
                </div>
              </>

        }

      </>
  );
};

export default CommunityMyQuestionsDetailed;